/* Version ------------------------------------------------- */
export const APP_VERSION = '2.7.15'; //actualizar cuando se compile alguna version 
                                    //el primer numero es un cambio realmente grande: una feature nueva
                                    //el segundo numero es añadir cosas a features existentes
                                    //el tercer numero es correccion de bugs

/* Páginas ------------------------------------------------- */
export const LOGIN_PAGE = 'LoginPage';
export const CLIENTS_PAGE = 'ClientsPage';
export const APPOINTMENTS_PAGE = 'AppointmentsPage';
export const COBERTURA_PAGE = 'CoberturasPage';
export const AFTER_CLIENTS_PAGE = APPOINTMENTS_PAGE;

/* Mensajes ------------------------------------------------ */
export const MSG_ERROR_RETRY = 'Ups! Algo salió mal, intente de nuevo';
export const MSG_ERROR_TIMEOUT = 'El servidor tardó demasiado en responder, intente de nuevo';
export const MSG_CONNECTED_TO = 'Está conectado a ';
export const MSG_SEARCH_MH_INST = 'Ingrese las tres primeras letras del apellido o el DNI, o busque por palabra clave en historia clínica';
export const MSG_ACTUALIZAR_APP = 'Existe una nueva version, por favor actualize la app';
export const MSG_ACTUALIZAR_WEB = 'Existe una nueva version, haga click en el icono para recargar';

/* Mensajes backend ---------------------------------------- */
export const MSG_BUSQUEDA_EXTENDIDA_INHABILITADA = 'Comuniquese para habilitar este servicio.';
export const FLAG_RELPACOB_VACIO =    '';
export const FLAG_RELPACOB_AGREGAR =  'agregar';
export const FLAG_RELPACOB_EDITAR =   'editar';
export const FLAG_RELPACOB_BORRAR =   'borrar';
/* Mensajes Receta Electronica ----------------------------- */
export const MSG_RECETA_ELECTRONICA_INHABILITADA = 'Comuniquese para habilitar este servicio.';
export const FLAG_RECETA_ELECTRONICA = 'RECETA_ELECTRONICA';
/* Mensajes cuando el paciente no es valido ---------------- */
export const MSG_BUSQUEDA_EXTENDIDA_NRODOC_NO_VALIDO =  "No se puede realizar la busqueda extendida:\nEl paciente posee el documento en cero.\nVerifique que sea correcto y vuelva a intentar.";
export const MSG_PACIENTE_NO_ENCONTRADO =  'Paciente no encontrado. Pruebe buscandolo en Historia Clínica';
export const MSG_PACIENTE_NO_REGISTADO =  'Paciente no registrado. Debe agregarlo primero.';
/* Constantes ---------------------------------------------- */
export const TOAST_DUR_NORMAL = 3000;
export const TOAST_DUR_LONG = 5000;
export const TOAST_DUR_EXTRA_LONG = 20000;
export const ADS_BANNER_INTERVAL = 60000;
export const ADS_BANNER_TIMEOUT = 20000;
export const SALA_ESPERA_POLL_INTERVAL_MS = 20000; //cada cuanto se consulta a la sala de espera
export const APPOINTMENTS_DAYS_AHEAD = 7;
export const AP_STATE_COLOR_SERVER = {A: '#e0e0e0', NO_DAR: '#ff8080', NEGRO: '#000000', BLANCO: '#ffffff'};//{S: 'apWait', A: 'apChecked', N: 'apNone'}; apChecked = #a39a8f = A_POTENCIADO, apNone =  #3faf41 = X = libre
export const AP_STATE_COLOR_APP = {S: 'apWait', A: 'apChecked', A_POTENCIADO: 'apChecked', N: 'apNone', X: 'apNone', NO_DAR: '#ff8080'};//{S: 'apWait', A: 'apChecked', N: 'apNone'}; apChecked = #a39a8f = A, apNone =  #3faf41 = X = libre
export const AP_STATE_COLOR = {S: 'apWait', A: 'apChecked', N: 'apNone'}; //esta es el array de colores original
export const AP_STATE_LABEL = {S: 'En Sala', A: 'Atendido', N: 'Pendiente'}; //{S: 'En espera', A: 'Atendido', N: 'Pendiente'};
export const LOCALE = 'es-AR';
// export const LOCALE_DATE_OPTIONS = { year: 'numeric', month: '2-digit', day: '2-digit' };
export const LOCALE_DATE_OPTIONS: Intl.DateTimeFormatOptions = {
  year: 'numeric',
  month: '2-digit',
  day: '2-digit'
};
export const NAME_APP_NO_AVAILABLE = 'NO DAR';
export const UNREGISTERED_PATIENT_ID = -1;
export const HORA_CORTE = 12;

/* Eventos ------------------------------------------------- */
export const EVT_MH_REFRESH = 'medicalHistory:refresh';
export const EVT_CONERTURA_REFRESH = 'coberturas:refresh';
export const EVT_APPOINTMENT_REFRESH = 'appointments:refresh';
export const EVT_SESSION_EXPIRED = 'session:expired';
export const EVT_SESSION_CLIENT_CHANGED = 'session:clientChanged';
export const EVT_RESIZE_CONTENT = 'resizeContent';
export const EVT_SINONIMOS_RECETARIO_REFRESH = 'recargar sinonimos mediware-recetario';

/* Paths --------------------------------------------------- */
export const DIR_DOWNLOADS = 'downloads';
/* LocalStorage para el login ------------------------------ */
export const STORAGE = {
  ENROLL_ID: 'enroll_id',
  PASSWORD: 'password',
  REMEMBER_ME: 'remember_me',
}
/* Tamaño del array del log de errores local --------------- */
export const MAX_ITEMS_ERRORLOG = 20;

export const TIEMPO_DETECCION_CAMBIOS_INPUT = 500;
export const TIEMPO_REUTILIZACION_BUSQUEDA_PACIENTE = 3000;



// WEBPACK FOOTER //
// ./src/constants.ts